<template>
  <div class="advantageProduct">
    <div class="compText">
      打造产品智慧工厂：搭建涵盖企业、个人、家庭的产品链，构建覆盖客户全生命周期和全健康周期的保险产品链；强大的产品精算及开发能力，打造多场景下的产品+ 服务的开发及定制能力，全方位满足平台客户需求。</div>
    <div class="middle">
      <div class="businessItem">
        <div class="itemTitle">1000</div>
        <div class="itemText">中介共享平台过千款产品直投</div>
      </div>
      <div class="businessItem">
        <div class="itemTitle">20</div>
        <div class="itemText">共签约数十家保险公司，涵盖个人寿险业务、团体寿险业务、财险业务等多个渠道</div>
      </div>
      <div class="businessItem">
        <div class="itemTitle">20</div>
        <div class="itemText">已为20多个行业定制个性化保险产品，包括行业特点定制、产品流程定制、弹性福利定制、员工团购定制等</div>
      </div>
      <div class="businessItem">
        <div class="itemTitle">30</div>
        <div class="itemText">已与多家保司合作，联合开发30余款创新型产品，满足不同层次、不同年龄、多方位的产品需求</div>
      </div>
    </div>
    <div class="colorTitle">
      <span>///</span> 合作产品 <span>///</span>
    </div>
    <!-- <div class="cooperContent">
      <img src="../assets/images/picture_10.png" alt="">
    </div> -->
    <div class="cooperContent">
      <div class="cooperImg">
        <img style="width:140px;" src="../assets/images/logo_1.png" alt="">
      </div>
      <div class="cooperImg">
        <img style="width:156px;" src="../assets/images/logo_2.png" alt="">
      </div>
      <div class="cooperImg">
        <img style="width:124px;" src="../assets/images/logo_3.png" alt="">
      </div>
      <div class="cooperImg">
        <img style="width:124px;" src="../assets/images/logo_4.png" alt="">
      </div>
      <div class="cooperImg">
        <img style="width:156px;" src="../assets/images/logo_5.png" alt="">
      </div>
      <div class="cooperImg">
        <img style="width:112px;" src="../assets/images/logo_6.png" alt="">
      </div>
      <div class="cooperImg">
        <img style="width:130px;" src="../assets/images/logo_7.png" alt="">
      </div>
      <div class="cooperImg">
        <img style="width:146px;" src="../assets/images/logo_8.png" alt="">
      </div>
      <div class="cooperImg">
        <img style="width:134px;" src="../assets/images/logo_9.png" alt="">
      </div>
      <div class="cooperImg">
        <img style="width:122px;" src="../assets/images/logo_10.png" alt="">
      </div>
      <div class="cooperImg">
        <img style="width:80px;" src="../assets/images/logo_11.png" alt="">
      </div>
    </div>
    <!-- <div style="text-align: center;color: #999999; margin-top: 60px;">
      展示更多内容+
    </div> -->

  </div>
</template>

<script>
export default {
  name: 'advantageProduct',
  components: {},
  data() {
    return {

    }
  },
  computed: {},
  created() { },
  mounted() { },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "../styles/face";

.advantageProduct {
  width: 1024px;
  margin: 0 auto;

  &>div {
    margin-top: 40px;
    position: relative;

    .ideaText {
      width: 100%;
      color: #ffffff;
      position: absolute;
      top: 110px;
      text-align: center;

      &>div:first-child {
        font-weight: 600;
      }
    }

    img {
      width: 100%;
    }
  }

  .middle {
    display: flex;
    justify-content: space-between;

    .businessItem {
      width: 238px;
      height: 301px;
      box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);
      padding: 40px 30px;

      .itemTitle {
        font-family: 'number-special' !important;
        font-size: 66px;
        font-weight: 600;
        text-align: center;
        color: #FE7A27;
      }

      .itemText {
        color: #666666;
        padding-top: 20px;
        margin-top: 20px;
        border-top: 4px solid #DFDFDF;
      }
    }
  }

  .cooperContent {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-around;
    width: 1024px;
    margin: 48px auto;
    background-color: #FBFBFB;
    padding: 10px 10px 40px 40px;

    .cooperImg {
      width: 166px;
      height: 84px;
      margin-top: 30px;
      margin-right: 28px;
      border: 1px solid #E7E7E7;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #ffffff;

      img {
        display: block;
      }
    }
  }
}
</style>